import React from 'react';
import { useQuery } from '@apollo/client';
import BiometricSettingsQuery from './BiometricSettingsQuery';

type result = {
  loading: boolean;
  biometricSettingsData?: any;
};

interface IBiometricSettingsConnectorApolloProps {
  children: (result: result) => React.ReactElement;
}

export const BiometricSettingsConnectorApollo: React.FC<IBiometricSettingsConnectorApolloProps> = ({
  children,
}) => {
  const { loading, data, error } = useQuery(BiometricSettingsQuery);

  const result: result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.biometricSettingsData = data;
  }

  return children(result);
};

export default BiometricSettingsConnectorApollo;
